export function normalizePriceImpact(priceImpact) {
  return Number(priceImpact.multiply(-1).toFixed(3));
}
